import type { ReactNode } from 'react';
import { Inbox } from 'lucide-react';

export function EmptyState({ title, hint, action }: { title: string; hint?: string; action?: ReactNode }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 gap-3">
      <div className="w-14 h-14 rounded-full bg-surface-container-high flex items-center justify-center text-on-surface-variant">
        <Inbox className="w-6 h-6" />
      </div>
      <p className="font-display font-bold text-on-surface">{title}</p>
      {hint && <p className="text-xs text-on-surface-variant max-w-sm">{hint}</p>}
      {action}
    </div>
  );
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="p-4 rounded-xl border border-red-500/30 bg-red-500/10 text-red-300 text-sm flex items-center justify-between gap-4">
      <span>{message}</span>
      {onRetry && (
        <button
          onClick={onRetry}
          className="px-3 py-1.5 rounded-md text-[10px] font-bold uppercase tracking-widest border border-red-400/40 hover:bg-red-500/20"
        >
          Retry
        </button>
      )}
    </div>
  );
}
